var InputSize = /* @__PURE__ */ ((InputSize2) => {
  InputSize2["MINI"] = "mini";
  InputSize2["SMALL"] = "small";
  InputSize2["MEDIUM"] = "medium";
  InputSize2["LARGE"] = "large";
  InputSize2["HUGE"] = "huge";
  return InputSize2;
})(InputSize || {});
const WsInputEnum = {
  Size: InputSize
};
export {
  InputSize,
  WsInputEnum,
  WsInputEnum as default
};
//# sourceMappingURL=WsInput.enum.es.js.map
